import { useState } from "react";
import AdminLayout from "../../layouts/AdminLayout";
import { addPlan } from "../../services/subscriptionService";
import "./AddPlan.css";
import { useNavigate } from "react-router-dom";

export default function AddPlan() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    planName: "",
    price: "",
    duration: "",
    months: "",

    features: {
      memberLimit: "",
      trainerLimit: "",
      storageLimit: "",

      attendance: false,
      membershipPlans: false,
      payments: false,
      trainers: false,
      reports: false,
      qrScanner: false,
      memberPortal: false,
      dietPlan: false,
      aiWorkout: false,
      customerSupport: false,
    },
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLimitChange = (e) => {
    setFormData({
      ...formData,
      features: {
        ...formData.features,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleFeatureChange = (e) => {
    setFormData({
      ...formData,
      features: {
        ...formData.features,
        [e.target.name]: e.target.checked,
      },
    });
  };

  const handleSubmit = async () => {
    if (!formData.planName) {
      return alert("Please select a plan.");
    }

    if (!formData.price) {
      return alert("Enter plan price.");
    }

    if (!formData.duration) {
      return alert("Select duration.");
    }

    if (!formData.features.memberLimit) {
      return alert("Enter member limit.");
    }
    try {
      await addPlan({
        ...formData,
        createdAt: new Date().toISOString(),
      });

      alert("Subscription Plan Added Successfully");

      navigate("/admin/subscriptions");

      setFormData({
        planName: "",
        price: "",
        duration: "",
        months: "",
        features: {
          memberLimit: "",
          trainerLimit: "",
          storageLimit: "",
          attendance: false,
          membershipPlans: false,
          payments: false,
          trainers: false,
          reports: false,
          qrScanner: false,
          memberPortal: false,
          dietPlan: false,
          aiWorkout: false,
          customerSupport: false,
        },
      });
    } catch (error) {
      console.error(error);
      alert("Failed to add plan.");
    }
  };

  // const featureLabels = {
  //   attendance: "Attendance",
  //   membershipPlans: "Membership Plans",
  //   payments: "Payments",
  //   trainers: "Trainer Management",
  //   reports: "Reports",
  //   qrScanner: "QR Scanner",
  //   memberPortal: "Member Portal",
  //   dietPlan: "Diet Plan",
  //   aiWorkout: "AI Workout",
  //   customerSupport: "Customer Support",
  // };

  return (
    <AdminLayout>
      <div className="add-plan-page">
        <div className="add-plan-header">
          <div>
            <h1>Create Subscription Plan</h1>
            <p>Create pricing plans for gym subscriptions and memberships.</p>
          </div>
        </div>

        <div className="add-plan-card">
          <div className="card-title">
            <h2>Plan Information</h2>
            <span>Configure plan details</span>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>Plan Name</label>

              <select
                name="planName"
                value={formData.planName}
                onChange={handleChange}
              >
                <option value="">Select Plan Type</option>
                <option value="Basic">Basic</option>
                <option value="Standard">Standard</option>
                <option value="Premium">Premium</option>
              </select>
            </div>

            <div className="form-group">
              <label>Months</label>

              <input
                type="number"
                name="months"
                placeholder="1"
                value={formData.months}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Price (₹)</label>

              <input
                type="number"
                name="price"
                placeholder="999"
                value={formData.price}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Duration (Days)</label>

              <select
                name="duration"
                value={formData.duration}
                onChange={handleChange}
              >
                <option value="">Select Duration</option>
                <option value="30 Days">30 Days</option>
                <option value="60 Days">60 Days</option>
                <option value="90 Days">90 Days</option>
                <option value="180 Days">180 Days</option>
                <option value="365 Days">365 Days</option>
              </select>
            </div>

            <div className="form-group">
              <label>Member Limit</label>

              <input
                type="number"
                name="memberLimit"
                value={formData.features.memberLimit}
                onChange={handleLimitChange}
              />
            </div>

            <div className="form-group">
              <label>Trainer Limit</label>

              <input
                type="number"
                name="trainerLimit"
                value={formData.features.trainerLimit}
                onChange={handleLimitChange}
              />
            </div>

            <div className="form-group">
              <label>Storage (MB)</label>

              <input
                type="number"
                name="storageLimit"
                value={formData.features.storageLimit}
                onChange={handleLimitChange}
              />
            </div>
            <div className="features-section">
              <h2>Available Features</h2>

              <div className="feature-grid">
                {Object.entries(formData.features)
                  .filter(
                    ([key]) =>
                      !["memberLimit", "trainerLimit", "storageLimit"].includes(
                        key,
                      ),
                  )
                  .map(([key, value]) => (
                    <label className="feature-item" key={key}>
                      <input
                        type="checkbox"
                        name={key}
                        checked={value}
                        onChange={handleFeatureChange}
                      />

                      {key}
                    </label>
                  ))}
              </div>
            </div>
          </div>

          <div className="plan-preview">
            <h3>Plan Preview</h3>

            <div className="preview-card">
              <h2>{formData.planName || "Plan Name"}</h2>

              <h1>₹{formData.price || 0}</h1>

              <p>{formData.duration || "Duration"}</p>

              <hr />

              <div className="preview-limits">
                <p>
                  Members
                  <span>{formData.features.memberLimit || 0}</span>
                </p>

                <p>
                  Trainers
                  <span>{formData.features.trainerLimit || 0}</span>
                </p>

                <p>
                  Storage
                  <span>{formData.features.storageLimit || 0} MB</span>
                </p>
              </div>
            </div>
          </div>

          <div className="feature-summary">
            <h4>Enabled Features</h4>

            <h2>
              {
                Object.values(formData.features).filter(
                  (value) => value === true,
                ).length
              }
            </h2>
          </div>

          <button className="save-plan-btn" onClick={handleSubmit}>
            Save Subscription Plan
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
